var _path;
import * as React from "react";
function SvgChevronLightUp(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.254 27.464l1.43 1.431a.867.867 0 001.227 0L20 15.837l13.089 13.058a.867.867 0 001.226 0l1.431-1.43a.867.867 0 000-1.227L20.613 11.105a.867.867 0 00-1.226 0L4.254 26.238a.867.867 0 000 1.226z"
  })));
}
export default SvgChevronLightUp;